import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { useFormikContext } from 'formik';
import { useWizardState } from '../WizardContext';

export const NextButton = ({
  isContinuable,
  setTouched,
  validateForm,
  submitForm,
  children,
}) => {
  const handleOnClick = () => validateForm()
    .then((errors) => {
      if (_.isEmpty(errors)) {
        submitForm();
      } else {
        setTouched(errors);
      }
    });
  return isContinuable ? children(handleOnClick) : null;
};

NextButton.propTypes = {
  children: PropTypes.func,
  isContinuable: PropTypes.bool,
  setTouched: PropTypes.func,
  submitForm: PropTypes.func,
  validateForm: PropTypes.func,
};

NextButton.defaultProps = {
  children: (() => {}),
  isContinuable: false,
  setTouched: (() => {}),
  submitForm: (() => {}),
  validateForm: (() => {}),
};

const NextButtonContext = (props) => {
  const { isContinuable } = useWizardState();
  const { setTouched, validateForm, submitForm } = useFormikContext();

  return (
    <NextButton
      {...props}
      {...{
        isContinuable,
        setTouched,
        submitForm,
        validateForm,
      }}
    />
  );
};

export default NextButtonContext;
